import { useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export interface FieldContext {
  fieldName: string;
  pageContext?: string;
  brandId?: string | null;
  additionalContext?: string;
  currentValue?: string;
}

export const useAiCopySuggestion = () => {
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { toast } = useToast();

  const generateSuggestions = useCallback(async (context: FieldContext) => {
    setIsLoading(true);
    setIsOpen(true);
    setSuggestions([]);

    try {
      const { data, error } = await supabase.functions.invoke('suggest-copy', {
        body: context
      });

      if (error) {
        throw error;
      }

      if (data?.suggestions && Array.isArray(data.suggestions)) {
        setSuggestions(data.suggestions);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error: any) {
      console.error('Error generating suggestions:', error);
      toast({
        title: 'Failed to generate suggestions',
        description: error.message || 'Please try again later',
        variant: 'destructive',
      });
      setIsOpen(false);
    } finally {
      setIsLoading(false);
    }
  }, [toast]);

  const dismiss = useCallback(() => {
    setIsOpen(false);
    setSuggestions([]);
  }, []);

  return {
    suggestions,
    isLoading,
    isOpen,
    generateSuggestions,
    dismiss,
  };
};
